import * as React from "react";
import type { SVGProps } from "react";
export const SvgLolTwitchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M3.584 2.5h13.917v9.75l-3.917 3.917h-3.25l-2.083 2H5.834v-2H2.501v-11L3.584 2.5Zm.584 12H7.5v2h.08l2.083-2h3.23l2.94-2.94V4.167H4.168V14.5ZM12.5 6.667h1.667v3.916H12.5V6.667Zm0 0h1.667v3.916H12.5V6.667Zm-4.167 0h1.667v3.916H8.334V6.667Z" />
  </svg>
);
